export default __webpack_public_path__ + "static/2-554826637dbd3a2938a8a78ad2310a50.jpeg";